import { GENERIC_ERROR_MESSAGE, STATUS_FAILURE, STATUS_PENDING, STATUS_SUCCESS } from 'Common/constants/commonConstants';
import  * as BasicSearchConstants from './BasicSearchConstants';
import { produce, current, original } from "immer";

// Object.assign is not yet fully supported in all browsers, so we fallback to
// a polyfill
const assign = Object.assign || require('object.assign');


// The initial application state
const initialState = {
    isFetching : false,
    isFetched : false,
    deviceFound: true,
    noDeviceFound: false,
    accessDenied: false,
    allowedModelsForMetering: [],
    fetchAllowedModelsForMeteringSts: STATUS_SUCCESS,
    fetchAllowedModelsForMeteringErrMsg: ""
};
// Takes care of changing the application state
export default function BasicDeviceSearchReducer(state = initialState, action) {
    switch (action.type) {

        case BasicSearchConstants.BASIC_DEVICE_SEARCH_FETCH_REQUEST:
            return assign({}, state, {
                    isFetching : true,
                    isFetched : false,
                    deviceFound: false,
                    noDeviceFound: false
            });
        case BasicSearchConstants.BASIC_DEVICE_SEARCH_FETCH_SUCCESS: {
                let instDetails = action.newState.result[0];
                let instId = instDetails.instanceId;
                let newState = {
                    isFetching : false,
                    isFetched : true,
                    deviceFound: true                   
                }
                
                newState[instId] = { 
                    ...instDetails,
                    showFileAccessModal: false,
                    assaynamefetching: false,
                    assaynamefetched: false,
                    assaynameCal: null,
                    assaynameQC: null,
                    assayLotfetching: false,
                    assayLotfetched: false,
                    assayMapCal: null,
                    assayMapQC: null,
                    metricsLatestDtTmFetching: false,
                    metricsLatestDtTmFetched: false,
                    metricsLatestDtTmMap: {},
                    eventDetailsFetching : false,
                    eventDetailsFetched : false,
                    eventDetailsFetchFailed : false,
                    eventFilterDataFetching : false,
                    eventFilterDataFetched : false,
                    eventFilterDataFetchFailed : false,
                    eventDetailsResult : {},
                    eventFilterData : {},
                    isPowerBiDataFetched: false,
                    updateMeteringStatus: STATUS_SUCCESS,
                    updateMeteringStatusErrMsg: ""
                };
                return assign({},state,newState);
        }
        case BasicSearchConstants.BASIC_DEVICE_SEARCH_FETCH_ACCESS_DENIED: {
            return assign({},state,{...state,
                isFetching : false,
                isFetched : true,
                deviceFound: false,
                accessDenied: action.newItem
            });
        }
        case BasicSearchConstants.BASIC_DEVICE_SEARCH_FETCH_FAILURE:
            return assign({}, state, {
                    isFetching : false,
                    isFetched : true,
                    deviceFound: false,
                    noDeviceFound: true
                });
        case BasicSearchConstants.BASIC_DEVICE_SEARCH_RESET_NO_DATA_FOUND:
            return assign({}, state, {
                noDeviceFound: false,
                deviceFound: false,
            });
        case BasicSearchConstants.CLEAR_INSTRUMENT_INSTANCE: {
            // Remove the stale instance data so the spinner shows immediately
            // on the instrument dashboard, even when Redux already holds data
            // from the home-page search.
            const next = assign({}, state);
            delete next[action.instanceId];
            return next;
        }
        case BasicSearchConstants.DEVICE_HEART_BEAT_FETCH_SUCCESS:{
            let heartBeatMsg = action.newState.result[0];
            let instId = heartBeatMsg.instanceId;
            if(!instId){
                instId = heartBeatMsg.deviceId;
            }
            
            const newState = produce(state, draft=>{
                if(draft[instId]){
                    draft[instId].lastConnectionDateTime = heartBeatMsg.lastConnectionDateTime;
                    draft[instId].lastConnectionDuration = heartBeatMsg.lastConnectionDuration;
                    draft[instId].connectionStatus = heartBeatMsg.connectionStatus;
                    draft[instId].instModeStatus = heartBeatMsg.instModeStatus;
                }
                draft.deviceFound = false;
            })

            return assign({},state,newState);
        }
        case BasicSearchConstants.DEVICE_DEMOGRAPHICS_FETCH_REQUEST:
            return assign({}, state, {
                isFetching : true,
                isFetched : false,
            });
        case BasicSearchConstants.DEVICE_DEMOGRAPHICS_FETCH_FAILURE:
            return assign({}, state, {
                isFetching: false,
                isFetched: false,
            });
        case BasicSearchConstants.DEVICE_DEMOGRAPHICS_FETCH_SUCCESS:{
            let demographicsMsg = action.newState.result[0];
            let instId = demographicsMsg.instanceId;
            const newState = produce(state, draft=>{
                if (!draft[instId]) { 
                    draft[instId] = {}; 
                }
                draft[instId].serialNumber = demographicsMsg.serialNumber;
                draft[instId].siteCity = demographicsMsg.siteCity;
                draft[instId].siteState = demographicsMsg.siteState;
                draft[instId].location = demographicsMsg.location;
                draft[instId].customer = demographicsMsg.customer;
                draft[instId].contactPerson = demographicsMsg.contactPerson;
                draft[instId].countryCode = demographicsMsg.countryCode;
                draft[instId].phoneNumber = demographicsMsg.phoneNumber;
                draft[instId].address = demographicsMsg.address;
                draft[instId].country = demographicsMsg.country;
                draft[instId].customerId = demographicsMsg.customerId;
                draft[instId].siteId = demographicsMsg.siteId;
                draft[instId].siteName = demographicsMsg.siteName;
                draft.isFetched = true;
                draft.isFetching = false;
            })
            return assign({},state,newState);
        }

        case BasicSearchConstants.DEVICE_RECENT_ASSAY_FETCH_REQUEST:{
            const newState = produce(state, (draft) => {
                if(draft[action.payload]) {
                    draft[action.payload] = {
                        ...draft[action.payload],
                        assaynamefetching : true,
                        assaynamefetched : false,
                        assaynameCal: null,
                        assaynameQC: null
                    };
                }
            });
            return assign({}, state, newState);
        }

        case BasicSearchConstants.DEVICE_RECENT_ASSAY_FETCH_SUCCESS:{
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        assaynamefetching : false,
                        assaynamefetched : true,
                        assaynameCal: action.payload.result.Calibration,
                        assaynameQC: action.payload.result.QC
                    };
                }
            });
            return assign({}, state, newState);
        }

        case BasicSearchConstants.DEVICE_RECENT_ASSAY_FETCH_FAILURE:{
            const newState = produce(state, (draft) => {
                if(draft[action.payload]) {
                    draft[action.payload] = {
                        ...draft[action.payload],
                        assaynamefetching : false,
                    };
                }
            });
            return assign({}, state, newState);
        }

        case BasicSearchConstants.DEVICE_LATEST_LOT_ALL_ASSAY_REQUEST:{
            const newState = produce(state, (draft) => {
                if(draft[action.payload]) {
                    draft[action.payload] = {
                        ...draft[action.payload],
                        assayLotfetching : true,
                        assayLotfetched : false,
                        assayMapCal: null,
                        assayMapQC: null
                    };
                }
            });
            return assign({}, state, newState);
        }

        case BasicSearchConstants.DEVICE_LATEST_LOT_ALL_ASSAY_SUCCESS:{
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        assayLotfetching : false,
                        assayLotfetched : true,
                        assayMapCal: action.payload.result.Calibration,
                        assayMapQC: action.payload.result.QC
                    };
                }
            });
            return assign({}, state, newState);
        }

        case BasicSearchConstants.DEVICE_LATEST_LOT_ALL_ASSAY_FAILURE: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload]) {
                    draft[action.payload] = {
                        ...draft[action.payload],
                        assayLotfetching : false,
                    };
                }
            });
            return assign({}, state, newState);
        }

        case BasicSearchConstants.DEVICE_METRIC_RECENT_DATETIME_REQUEST:{
            const newState = produce(state, (draft) => {
                if(draft[action.payload]) {
                    draft[action.payload] = {
                        ...draft[action.payload],
                        metricsLatestDtTmFetching : true,
                        metricsLatestDtTmFetched : false
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.DEVICE_METRIC_RECENT_DATETIME_SUCCESS:{
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        metricsLatestDtTmFetching : false,
                        metricsLatestDtTmFetched : true,
                        metricsLatestDtTmMap: action.payload.result
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.DEVICE_METRIC_RECENT_DATETIME_FAILURE : {
            const newState = produce(state, (draft) => {
                if(draft[action.payload]) {
                    draft[action.payload] = {
                        ...draft[action.payload],
                        metricsLatestDtTmFetching : false,
                        metricsLatestDtTmFetched : false
                    };
                }
            });
            return assign({}, state, newState);
        }

        case BasicSearchConstants.DEVICE_EVENT_DETAILS_FETCH_REQUEST:{
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        eventDetailsResult: {
                            ...draft[action.payload.instanceId]?.eventDetailsResult,
                            eventDetails: action.payload.fetchNext ? draft[action.payload.instanceId]?.eventDetailsResult?.eventDetails : []
                        },
                        eventDetailsFetching : true,
                        eventDetailsFetched : false,
                        eventDetailsFetchFailed : false,
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.DEVICE_EVENT_DETAILS_FETCH_SUCCESS:{
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        eventDetailsFetching : false,
                        eventDetailsFetched : true,
                        eventDetailsResult : {
                            ...action.payload.newState,
                            eventDetails: action.payload.fetchNext ? [...draft[action.payload.instanceId]?.eventDetailsResult?.eventDetails, ...action.payload.newState.eventDetails] : action.payload.newState.eventDetails,
                            hasMore: action.payload.newState.eventDetails?.length === action.payload.requestedPageSize
                        }
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.DEVICE_EVENT_DETAILS_FETCH_FAILURE : {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        eventDetailsFetching : false,
                        eventDetailsFetched : false,
                        eventDetailsFetchFailed : true
                    };
                }
            });
            return assign({}, state, newState);
        }

        case BasicSearchConstants.FILE_ACCESS_MODAL_CONTROL:
            const newState = produce(state, draft => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId].showFileAccessModal = action.payload.showModal;
                }
            });
            return assign({}, state, newState);

        case BasicSearchConstants.FETCH_ALLOWED_MODELS_FOR_METERING_REQUEST: {
            const newState = {
                ...state,
                allowedModelsForMetering: [],
                fetchAllowedModelsForMeteringSts: STATUS_PENDING,
                fetchAllowedModelsForMeteringErrMsg: ""
            };

            return assign({}, state, newState);
        }
        case BasicSearchConstants.FETCH_ALLOWED_MODELS_FOR_METERING_SUCCESS: {
            const newState = {
                ...state,
                allowedModelsForMetering: [...action.payload],
                fetchAllowedModelsForMeteringSts: STATUS_SUCCESS,
            };

            return assign({}, state, newState);
        }
        case BasicSearchConstants.FETCH_ALLOWED_MODELS_FOR_METERING_FAILURE: {
            const newState = {
                ...state,
                fetchAllowedModelsForMeteringSts: STATUS_FAILURE,
                fetchAllowedModelsForMeteringErrMsg: GENERIC_ERROR_MESSAGE
            };

            return assign({}, state, newState);
        }

        case BasicSearchConstants.UPDATE_DEVICE_METERING_STATUS_REQUEST: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        updateMeteringStatus: STATUS_PENDING,
                        updateMeteringStatusErrMsg: ""
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.UPDATE_DEVICE_METERING_STATUS_SUCCESS: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        metered: action.payload.result,
                        updateMeteringStatus: STATUS_SUCCESS,
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.UPDATE_DEVICE_METERING_STATUS_FAILURE: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        updateMeteringStatus: STATUS_FAILURE,
                        updateMeteringStatusErrMsg: action.payload.error
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.FETCH_TRIGGER_ACTIVITY: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        triggerActivity: action.payload.result
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.FETCH_TRIGGER_AUDIT_COUNT: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        triggerAuditCount: action.payload.result
                    };
                }
            });
            return assign({}, state, newState);
        }

        case BasicSearchConstants.GET_MAINTENANCE_DOMAINS_REQUEST: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        fetchMaintenanceDomainsStatus : STATUS_PENDING,
                        maintenanceDomains: []
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.GET_MAINTENANCE_DOMAINS_SUCCESS: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        fetchMaintenanceDomainsStatus : STATUS_SUCCESS,
                        maintenanceDomains : action.payload.newState
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.GET_MAINTENANCE_DOMAINS_FAILURE: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        fetchMaintenanceDomainsStatus : STATUS_FAILURE,
                        maintenanceDomains: []
                    };
                }
            });
            return assign({}, state, newState);
        }

        case BasicSearchConstants.GET_MAINTENANCE_DATA_REQUEST: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        fetchMaintenanceDataStatus : STATUS_PENDING,
                        maintenanceData: []
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.GET_MAINTENANCE_DATA_SUCCESS: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        fetchMaintenanceDataStatus : STATUS_SUCCESS,
                        maintenanceData : action.payload.newState
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.GET_MAINTENANCE_DATA_FAILURE: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        fetchMaintenanceDataStatus : STATUS_FAILURE,
                        maintenanceData: []
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.GET_MAINTENANCE_DETAILS_REQUEST: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        fetchMaintenanceDetailsStatus : STATUS_PENDING,
                        maintenanceDetails: []
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.GET_MAINTENANCE_DETAILS_SUCCESS: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        fetchMaintenanceDetailsStatus : STATUS_SUCCESS,
                        maintenanceDetails : action.payload.newState
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.GET_MAINTENANCE_DETAILS_FAILURE: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        fetchMaintenanceDetailsStatus : STATUS_FAILURE,
                        maintenanceDetails: []
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.GET_SUPPORTED_FEATURES_REQUEST: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        fetchSupportedFeatures : STATUS_PENDING,
                        supportedFeaturesForModel: {}
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.GET_SUPPORTED_FEATURES_SUCCESS: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        fetchSupportedFeatures : STATUS_SUCCESS,
                        supportedFeaturesForModel : action.payload.result
                    };
                }
            });
            return assign({}, state, newState);
        }
        case BasicSearchConstants.GET_SUPPORTED_FEATURES_FAILURE: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        fetchSupportedFeatures : STATUS_FAILURE,
                        supportedFeaturesForModel: {}
                    };
                }
            });
            return assign({}, state, newState);
        }
        default:
            return state;
    }
}